module.exports = __webpack_public_path__ + "static/media/mobile.d1717390.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/customerexpert/landingpage/mobile.png
// module id = 1619
// module chunks = 0